import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Chat from "./components/Chat";
import NewConnection from "./components/NewConnection";
import PrivateRoute from "./components/PrivateRoute";
import GlobalStyles from "./styles/GlobalStyles";

const App: React.FC = () => (
  <>
    <GlobalStyles />
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
  path="/chat/:chatId"
  element={
    <PrivateRoute>
      <Chat />
    </PrivateRoute>
  }
/>
<Route
  path="/chat"
  element={
    <PrivateRoute>
      <Chat />
    </PrivateRoute>
  }
/>


      <Route
        path="/new-connection"
        element={
          <PrivateRoute>
            <NewConnection />
          </PrivateRoute>
        }
      />

      {/* Всё остальное → /chat */}
      <Route path="*" element={<Navigate to="/chat" replace />} />
    </Routes>
  </>
);

export default App;
